<div class="tendenz" [ngStyle]="containerStyle()">
  <!-- Editierbare Temperaturen (eine je Tag) -->
  <div class="tendenz__temps">
    @for (p of points; track $index) {
      <input class="tendenz__temp-input"
             inputmode="numeric"
             [value]="p.value"
             (change)="onTempInput($index, $any($event.target).value)">
    }
  </div>

  <!-- Diagramm: Fehlerband + weiße Trendlinie -->
  <svg class="tendenz__chart" [attr.viewBox]="'0 0 ' + VB_WIDTH + ' ' + VB_HEIGHT" preserveAspectRatio="none">
    <polygon [attr.points]="bandPoints" [attr.fill]="bandColor()" stroke="none"></polygon>
    <polyline [attr.points]="linePoints" fill="none" [attr.stroke]="lineColor()" stroke-width="6" stroke-linejoin="round"></polyline>
  </svg>

  <!-- Wochentage -->
  <div class="tendenz__weekdays">
    @for (p of points; track $index) {
      <div class="tendenz__weekday">{{ p.weekday }}</div>
    }
  </div>

  <span class="tendenz__scale tendenz__scale--max">{{ maxLabel }}</span>
  <span class="tendenz__scale tendenz__scale--min">{{ minLabel }}</span>
</div>
